//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "DialogSignUpSelection",

  data: function () {
    return {
      ages: [
        {label: "от 2 до 6 лет", age: "2-6", image: require("~/assets/jpg/appointment/child-1.jpg")},
        {label: "от 7 до 11 лет", age: "7-11", image: require("~/assets/jpg/appointment/child-2.jpg")},
        {label: "от 12 до 18 лет", age: "12-18", image: require("~/assets/jpg/appointment/child-3.jpg")},
        {label: "старше 18 лет", age: "19", image: require("~/assets/jpg/appointment/child-4.jpg")},
      ],

      selectedAge: "",
      type: "",

      isLoad: false
    }
  },

  methods: {

    open: function (type) {
      this.type = type;
      this.$modal.show('dialog-sign-up-selection')
    },
    close: function () {
      this.$modal.hide('dialog-sign-up-selection')
    },

    setSelectedAge: function (age) {
      this.selectedAge = age;
    },

    makeEntry: async function () {
      this.isLoad = true;
      const services = await this.$api.agent.transport.get(`/services/get-services-for-selection-by-type/${ this.type }`).then((res) => {
        return res.data
      }).catch(() => {
        return {}
      });
      const service = services.find((t) => t.age === this.selectedAge);
      const serviceId = service?.service_id;
      if (serviceId === undefined) {
        this.isLoad = false;
        this.$toast.error("Услуга не найдена");

        return
      }

      this.isLoad = false;
      await this.$router.push(`/zapis?step_age=${ this.selectedAge }&step_service=${ serviceId }`);
    }

  }
}
